"use client";

import { c as _c } from "react/compiler-runtime";
import { HospitalTabContent, ReviewTabContent, TreatmentCaseTabContent } from "@/widgets/hospital/ui/templates";
import useHospitalUIStore from "@/widgets/hospital/model/store";
import { TreatmentCaseFilterResponse } from "@/shared/types/type/treatment";
import { PartnerHospitalEquipment, PartnerHospitalOperation } from "@/entities/hospital/api/types";
interface HospitalContentProps {
  partnerHospital?: PartnerHospitalOperation;
  address: string;
  location: {
    latitude: number;
    longitude: number;
  };
  filterList: TreatmentCaseFilterResponse;
  hospitalTreatmentId: number;
  equipments: PartnerHospitalEquipment[];
  isPartner: boolean;
}
const HospitalContent = t0 => {
  const $ = _c(10);
  const {
    partnerHospital,
    address,
    location,
    equipments,
    filterList,
    hospitalTreatmentId,
    isPartner
  } = t0;
  const {
    selectedTab
  } = useHospitalUIStore();
  if (selectedTab === "review") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ReviewTabContent />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (selectedTab === "hospitalInfo") {
    const t1 = partnerHospital as PartnerHospitalOperation;
    let t2;
    if ($[1] !== address || $[2] !== equipments || $[3] !== isPartner || $[4] !== location || $[5] !== t1) {
      t2 = <HospitalTabContent partnerHospital={t1} address={address} location={location} equipments={equipments} isPartner={isPartner} />;
      $[1] = address;
      $[2] = equipments;
      $[3] = isPartner;
      $[4] = location;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t1;
  if ($[7] !== filterList || $[8] !== hospitalTreatmentId) {
    t1 = <TreatmentCaseTabContent filterList={filterList} hospitalTreatmentId={hospitalTreatmentId} />;
    $[7] = filterList;
    $[8] = hospitalTreatmentId;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
export default HospitalContent;